import { enableClient } from '@wix/cli-app/internal/platform-sdk/site';

const { injectGetAccessToken: injectAccessTokenGetter } = enableClient('6a30caff-5dc3-4e4c-ba70-19db988f5830');

export { injectAccessTokenGetter };

export { default } from '/src/site/components/Button/component.tsx';
export * from '/src/site/components/Button/component.tsx';